import { errorLogger, parseJson, stringifyJson } from './app/app.helpers'
import { stringToBool } from './string.helpers'

const REWARD_CODE = 'rewardCode'
const EMAIL_MISSING = 'emailMissing'
const FORCE_SIGNUP = 'forceSignup'
const REFERRAL = 'referral'
const LWA_CONF = 'lwaConf'

const setRewardCode = (rewardCode) => {
  try {
    localStorage.setItem(REWARD_CODE, rewardCode)
  } catch (e) {
    errorLogger(e)
  }
}

const getRewardCode = () => {
  return localStorage.getItem(REWARD_CODE) || ''
}

const removeRewardCode = () => {
  localStorage.removeItem(REWARD_CODE)
}

const setEmailMissing = (emailMissing) => {
  try {
    localStorage.setItem(EMAIL_MISSING, emailMissing)
  } catch (e) {
    errorLogger(e)
  }
}

const getEmailMissing = () => {
  return stringToBool(localStorage.getItem(EMAIL_MISSING)) || false
}

const removeEmailMissing = () => {
  localStorage.removeItem(EMAIL_MISSING)
}

const setForceSignup = (forceSignup) => {
  try {
    localStorage.setItem(FORCE_SIGNUP, forceSignup)
  } catch (e) {
    errorLogger(e)
  }
}

const getForceSignup = () => {
  return stringToBool(localStorage.getItem(FORCE_SIGNUP)) || false
}

const removeForceSignup = () => {
  localStorage.removeItem(FORCE_SIGNUP)
}

const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value)
}

const getLocalStorage = (name) => {
  return stringToBool(localStorage.getItem(name)) || false
}

const setReferral = (value) => {
  try {
    localStorage.setItem(REFERRAL, value)
  } catch (e) {
    errorLogger(e)
  }
}

const getReferral = () => {
  return localStorage.getItem(REFERRAL) || ''
}

const removeReferral = () => {
  localStorage.removeItem(REFERRAL)
}

const setLWAConf = (data) => {
  try {
    const updatedData = getLWAConf()
    localStorage.setItem(
      LWA_CONF,
      stringifyJson({
        ...updatedData,
        ...data
      })
    )
  } catch (e) {
    console.error(e)
  }
}

const getLWAConf = () => {
  const data = localStorage.getItem(LWA_CONF)
  return data ? parseJson(data) : {}
}

export {
  getEmailMissing,
  getForceSignup,
  getLocalStorage,
  getRewardCode,
  removeEmailMissing,
  removeForceSignup,
  removeRewardCode,
  setEmailMissing,
  setForceSignup,
  setLocalStorage,
  setRewardCode,
  setReferral,
  getReferral,
  removeReferral,
  getLWAConf,
  setLWAConf
}
